import { render, staticRenderFns } from "./Hotels.vue?vue&type=template&id=9e244be6&scoped=true"
import script from "./Hotels.vue?vue&type=script&lang=js"
export * from "./Hotels.vue?vue&type=script&lang=js"
import style0 from "./Hotels.vue?vue&type=style&index=0&id=9e244be6&prod&lang=scss&scoped=true"
import style1 from "./Hotels.vue?vue&type=style&index=1&id=9e244be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e244be6",
  null
  
)

export default component.exports